<template>
  <div style="margin-bottom: 0.5rem" class="lp-date-picker">
    <date-picker
      class="lp-datepicker"
      style="display: inline-block"
      v-model="date"
      @change="selDateTime"
      :lang="lang"
      type="datetime"
      format="YYYY-MM-DD HH:mm"
      :minute-step="10"
      :disabled="disabled"
      :not-before="not_before"
      v-if="type==='datetime'">
    </date-picker>

    <date-picker
      class="lp-datepicker"
      style="display: inline-block"
      v-model="date"
      :lang="lang"
      @change="selDateRange"
      :disabled="disabled"
      range
      format="YYYY-MM-DD"
      :not-before="not_before"
      width="210"
      v-else-if="type==='daterange'"></date-picker>

    <date-picker
      class="lp-datepicker"
      style="display: inline-block"
      v-model="date"
      :lang="lang"
      @change="selDateTimeRange"
      range
      type="datetime"
      format="YYYY-MM-DD HH:mm:ss"
      :disabled="disabled"
      :not-before="not_before"
      v-else-if="type==='datetimerange'"></date-picker>

    <date-picker
      class="lp-datepicker"
      style="display: inline-block"
      v-model="date"
      :lang="lang"
      @change="selDate"
      type="month"
      format="YYYY-MM"
      :disabled="disabled"
      :not-before="not_before"
      v-else-if="type==='month'"></date-picker>

    <date-picker
      class="lp-datepicker"
      style="display: inline-block"
      v-model="date"
      @change="selDate"
      :lang="lang"
      format="YYYY-MM-DD"
      :minute-step="10"
      :disabled="disabled"
      :not-before="not_before"
      v-else></date-picker>

  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      data: {
        type: [String, Date, Array]
      },
      type: {
        type: String,
        default: 'date'   //date, datetime, daterange, datetimerange
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholderDate: {
        type: String,
        default: '날짜 선택'
      },
      placeholderDateRange: {
        type: String,
        default: '기간 선택'
      },
      not_before: {
        type: String,
        default: ''
      }
    },

    data(){
      return {
        date:'',
        lang: {
          days: ['일', '월', '화', '수', '목', '금', '토'],
          months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
          pickers: ['7일다음', '30일다음', '7일이전', '30일이전'],
          placeholder: {
            date: '날짜 선택',
            dateRange: '기간 선택'
          }
        }
      }
    },
    created() {
      if(this.data) {
        if (this.type==='daterange' || this.type==='datetimerange') {
          let d1 = moment(this.data[0]);
          let d2 = moment(this.data[1]);
          this.date = [d1, d2];
        }
        else {
          if(typeof(this.data)==='string' && (
            this.data.indexOf('1111-01-01')>-1 || this.data.indexOf('9999-01-01')>-1)){
            this.date = '';
          } else if(this.data === null || this.data === undefined) {
            this.date = '';
          }
          else {
            this.date = moment(this.data).format('YYYY-MM-DD HH:mm');
          }
        }
      }


      this.lang.placeholder.date = this.placeholderDate;
      this.lang.placeholder.dateRange = this.placeholderDateRange;
    },
    watch:{
      data(n){
        if(typeof(n)==='string'){
          this.date = n;
          if(n.indexOf('1111-01-01')>-1){
            this.date = '';
          }
          if(n.indexOf('9999-01-01')>-1){
            this.date = '';
          }
        }
        else if (this.type==='daterange' || this.type==='datetimerange') {
          if (this.data && this.data.length > 0) {
            let d1 = moment(this.data[0]);
            let d2 = moment(this.data[1]);
            this.date = [d1, d2];
          }
          else {
            this.date = '';
          }
        } else if(n === undefined || n === null) {
          this.date = '';
        }
        /*else{
          this.date = new Date();
        }*/
      }
    },
    methods: {
      selDateRange(date){
        let date_range = [];
        if (date[0] && date[1]) {
          date_range.push(moment(date[0]).format('YYYY-MM-DD'));
          date_range.push(moment(date[1]).format('YYYY-MM-DD'));
        }
        this.$emit('setDate', date_range);
        this.$emit('update:data', date_range);
      },
      selDate(date){
        if(date !== null && date !== '') {
          date = moment(date).format('YYYY-MM-DD');
        } else {
          date = '';
        }
        this.$emit('setDate', date);
        this.$emit('update:data', date);
      },
      selDateTime(date){
        if(date !== null && date !== '') {
          date = moment(date).format('YYYY-MM-DD HH:mm');
        } else {
          date = '';
        }
        this.$emit('setDate', date);
        this.$emit('update:data', date);
      },
      selDateTimeRange(date){
        let date_time_range = [];
        date_time_range.push(moment(date[0]).format('YYYY-MM-DD HH:mm'));
        date_time_range.push(moment(date[1]).format('YYYY-MM-DD HH:mm'));
        this.$emit('setDate', date_time_range);
        this.$emit('update:data', date_time_range);
      }
    }
  }
</script>

<style lang="scss">

  .lp-dating {
    display:inline-block;
    margin: 0 8px;
    font-size: 18px;
    color:#064160;
  }

  .lp-date-picker ul {
    list-style: unset;
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  .mx-input {
    height: 31.5px !important;
  }

  .content .mx-calendar-content table tbody tr:last-child td, .content .mx-calendar-content table tbody tr:last-child th {
    border-width: 0 0 1px !important;
    border: unset !important;
  }
</style>
